import { ErpInvoiceState } from "./../dtos/erpInvoiceState";
import Vue from "vue";
import Vuex from "vuex";
import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";
import Oidc from "oidc-client";

Vue.use(Vuex);
const authorityUrl = process.env.VUE_APP_authorityUrl;
const redirectUri = process.env.VUE_APP_redirectUri;
const postLogoutRedirectUri = process.env.VUE_APP_postLogoutRedirectUri;

// STATE
const state = {
	// MAIN
	isAdmin: false,
	embedded: false,
	snackbarText: "",
	snackbarColor: "accent",
	userRights: {
		canProcessTicketAsBlexon: false,
		canProcessTicketAsFertiger: false,
	},

	// REGION
	regions: ["Schweiz/Liechtenstein", "Deutschland", "Österreich"],

	// CUSTOMER
	// [CustomerInfoDto[]]: Currently loaded customer data
	customers: [],
	// [number]: Total customer count for display in Kundenliste
	totalCustomerCount: 0,
	// [TagDto[]]: All available customer tags
	tags: [],
	// [TagDto[]]: Stores tag which are selected in the customer dashboard
	customerFilterTags: [],
	// [string[]]: All available customer countries
	countries: ["Schweiz", "Deutschland", "Österreich", "Liechtenstein", "Andere"],
	// [string[]]: Stores countries which are selected in the customer dashboard
	customerFilterCountries: ["Schweiz", "Deutschland", "Österreich", "Liechtenstein", "Andere"],
	// [string]: Search term in customer dashboard
	suchbegriff: "",
	// [CustomerSortingType]: How the customers are sorted
	customerSortingType: 1,
	// [boolean]: Is loading customers
	isLoadingCustomers: false,
	// [string]: Last search term that was filtered
	customerLastSearchTerm: "",
	// [boolean]: There are probably more customers to be loaded with the current filters
	hasMoreCustomersToLoad: true,
	// [boolean]: Indicating if the filtering should be affected by customer details
	customerVolltextSuche: false,
	// [number]: Amount of search results to be skipped. Used for "skipping" to a certain part of the customer base.
	// e.g. if the list is sorted by customer ids and manualSkip = 5000, results will show customers from "the middle" and upwards.
	manualSkip: 0,

	// CUSTOMER DETAIL
	// [CustomerInfoDto]: Customer info of currently loaded customer in detail view
	detailCustomerInfo: {},
	// [CustomerDetailsDeto]: Customer details of currently loaded customer in detail view
	detailCustomerDetails: {},

	// ORDER
	// Suchbegriff im order dashboard
	orderSuchbegriff: "",
	// Order states that should be returned. This is initialized at runtime via the enum.
	orderFilterStates: [],
	// Fertiger that should be returned in the order dashboard
	orderFilterFertiger: [],
	// Settings für Sortieren der Aufträge
	orderSortingType: 9,
	// [OrderCancellationRequestDto[]] Open cancellation requests
	orderCancellations: null,

	// ARTICLE
	articles: [],
	validationProgresses: [],
	// Flag indicating, if the articles should be reloaded when the component is mounted.
	// This is used to prevent a reload when returning from assembly view.
	reloadArticles: true,
	articleScrollPosition: 0,

	// TICKET
	ticketSettings: {
		showResolved: false,
	},

	// ACCOUNTING
	activeAccountingTab: 0,

	// Invoices
	invoices: [],
	invoiceSearchTerm: "",
	invoiceLastSearchTerm: "",
	invoiceCustomerNumber: "",
	invoiceLastCustomerNumber: "",
	invoiceSortingType: 3,
	invoiceFilterRegions: ["Schweiz/Liechtenstein", "Deutschland", "Österreich"],

	// Payments
	payments: [],
	paymentSearchTerm: "",
	paymentLastSearchTerm: "",
	paymentFilterRegions: ["Schweiz/Liechtenstein", "Deutschland", "Österreich"],
	paymentSorting: {
		sortBy: "dueDate",
		descending: false,
		rowsPerPage: -1, // Show All
	},

	// Transactions
	transactions: [],
	matchedInvoices: [],
	dueInvoices: [],
	dueInvoiceSearchTerm: "",
	dueInvoiceSorting: {
		sortBy: "paymentDate",
		descending: true,
		rowsPerPage: 50,
	},

	// Mahnungen
	mahnungen: [],
	mahnungSearchTerm: "",
	mahnungLastSearchTerm: "",
	mahnungSorting: {
		sortBy: "createdAt",
		descending: true,
		rowsPerPage: -1, // Show All
	},
	auditSorting: {
		sortBy: "date",
		descending: true,
		rowsPerPage: -1, // Show All
	},

	// FERTIGER
	// Fertiger von Blexon. Sollen später aus dem Fertigerportal geladen werden.
	fertigers: [
		{
			name: "RuossTech AG",
			id: 2,
		},
		{
			name: "CutCenter AG",
			id: 4,
		},
		{
			name: "USE Metalltechnik AG",
			id: 5,
		},
		{
			name: "Keller Laser AG",
			id: 6,
		},
		{
			name: "zweifel metall AG",
			id: 8,
		},
		{
			name: "Metallbaumontage Batzel",
			id: 9,
		},
	],

	oidc: {
		user: null,
		authenticated: false,
		instance: null,
		token: null,
		config: {
			//@ts-ignore
			userStore: new Oidc.WebStorageStateStore(),
			authority: authorityUrl,
			// Client application's identifier as registered on the Identityserver
			client_id: "HelpdeskClient",
			// Redirect URI of your client application to receive a response from the Identityserver
			redirect_uri: redirectUri,
			// The Identityserver post-logout redirect URI.
			post_logout_redirect_uri: postLogoutRedirectUri,
			// The type of response desired from the Identityserver.
			// "code" = Authorization Code Flow + PKCE (oidc-client generiert code_verifier/code_challenge
			// automatisch für response_type "code"). Ersetzt den veralteten Implicit Flow.
			response_type: "code",
			// The scope being requested from the Identityserver
			scope: "openid profile HelpdeskApi EventApi offline_access",
			silent_redirect_uri: window.location.origin + "/silent-renew.html",
			accessTokenExpiringNotificationTime: 601200, // 7 Tage minus 1 Stunde
			automaticSilentRenew: true,
			filterProtocolClaims: true,
			loadUserInfo: true,
		},
	},
};

export default new Vuex.Store({
	state,
	mutations,
	actions,
	getters,
});
